<div class="pvv-container" #pagesContainer>
  <div
    *ngFor="let pageNum of pageNumbers; trackBy: trackByPage"
    class="pvv-page-wrapper"
    [attr.data-page-number]="pageNum"
    #pageWrapperEl
  >
    <div class="pvv-page-label" *ngIf="showPageLabels">Page {{ pageNum }}</div>
    <div
      class="pvv-page-boundary page-boundary"
      [style.width.px]="getPageWidthPx(pageNum)"
      [style.height.px]="getPageHeightPx(pageNum)"
    >
      <canvas
        *ngIf="renderedPages.has(pageNum)"
        class="pvv-page-canvas"
        [attr.data-page-number]="pageNum"
        #canvasEl
      ></canvas>

      <ng-container
        *ngIf="showOverlayFor(pageNum)"
        [ngTemplateOutlet]="overlayTemplate!"
        [ngTemplateOutletContext]="{
          $implicit: pageNum,
          width: getPageWidthPx(pageNum),
          height: getPageHeightPx(pageNum)
        }"
      >
      </ng-container>
    </div>
  </div>
</div>
